class contracttplist extends Tango.Component {
	widgetDidMount() {
		document.getElementsByClassName("contracttpaction").forEach(function (el) {
			el.addEventListener("click", function (event) {
				const a = event.target.closest('a');
				const td = a.parentElement;
				const tr = td.parentElement;
				const h = td.querySelector("input[type='hidden']");
				const del = td.querySelector("a[data-action='delete']");
				const undel = td.querySelector("a[data-action='undelete']");
				if (a.getAttribute('data-action') == 'delete') {
					h.value = '1';
					del.classList.add('hide');
					undel.classList.remove('hide');
					tr.classList.add("deleterow");
				}
				else if (a.getAttribute('data-action') == 'undelete') {
					h.value = '0';
					undel.classList.add('hide');
					del.classList.remove('hide');
					tr.classList.remove("deleterow");
				}
 			});
		});
		document.querySelectorAll('.cal-date').forEach(function (el) {
			el.addEventListener("change", function (event) {
				const td = event.target.closest('td');
				td.classList.add('changedcell');
			});
		});
	}
};

Tango.registerComponent(contracttplist, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	listview: listview,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));